import { AutoCompleteIntegrator } from '../../components/ui/AutoCompleteIntegrator'
import { useCreateFinancingPerValueFormContext } from '../../hooks/useCreateFinancingPerValueForm'
import { useIsAdmin } from 'hooks/useIsAdmin'
import { ClearFieldsButton } from '../ui/ClearFieldsButton'
import { RadioPersonType } from '../ui/RadioPersonType'
import { MaskedMonetaryInput } from 'components/Controllers/MaskedMonetaryInput'
import {
  isFinancingPerValue,
  isFinancingPerQuotation,
} from 'containers/Financing/helpers/financingOrigin'
import * as S from './styles'

export function Commom() {
  const {
    control,
    formState: { errors, defaultValues },
  } = useCreateFinancingPerValueFormContext()

  const isAdmin = useIsAdmin()
  const isValueOrigin = isFinancingPerValue(defaultValues?.origin)
  const isQuotationOrigin = isFinancingPerQuotation(defaultValues?.origin)

  return (
    <S.Container>
      <section>
        <h3>Dados do financiamento</h3>

        <S.CommomGroup>
          <MaskedMonetaryInput
            label="Valor dos equipamentos"
            placeholder="R$ 0,00"
            disabled={isQuotationOrigin}
            autoFocus={isValueOrigin}
            error={errors.equipments_value?.message}
            control={control}
            name="equipments_value"
          />
          <MaskedMonetaryInput
            label="Valor da mão de obra"
            placeholder="R$ 0,00"
            error={errors.labor_value?.message}
            control={control}
            name="labor_value"
          />
          <MaskedMonetaryInput
            disabled
            label="Valor a Financiar"
            placeholder="R$ 0,00"
            error={errors.total_value?.message}
            control={control}
            name="total_value"
          />
        </S.CommomGroup>

        {isAdmin && isValueOrigin && (
          <AutoCompleteIntegrator
            label="Integrador Responsável"
            control={control}
            name="integrator"
            autoComplete="off"
            contentSide="top"
            offset={-20}
            error={errors.integrator?.id?.message}
          />
        )}
      </section>

      <section>
        <h3>Dados pessoais do cliente</h3>

        <div className="manage-person-type">
          <RadioPersonType />
          <ClearFieldsButton>Limpar dados</ClearFieldsButton>
        </div>
      </section>
    </S.Container>
  )
}
